import React from 'react';
import { Provider } from 'react-redux';
import { HashRouter } from 'react-router-dom'
import { ThemeSwitcherProvider } from 'react-css-theme-switcher';
import store from './store';
import Layouts from './layouts'
import { THEME_CONFIG } from './configs/AppConfig';
import { SocketProvider } from 'contexts/SocketContext';
import './lang'

const themes = {
  dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};

function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <SocketProvider>
          <HashRouter>
            <ThemeSwitcherProvider
              themeMap={themes}
              defaultTheme={THEME_CONFIG.currentTheme}
              insertionPoint="styles-insertion-point"
            >
              <Layouts />
            </ThemeSwitcherProvider>
          </HashRouter>
        </SocketProvider>
      </Provider>
    </div>
  );
}

export default App;
